import React, { Component } from "react";

class TextArea extends Component {
  render() {
    const { name, label, value, onChange, error } = this.props;
    return (
      <div className="form-group">
        <label className="normal-font" htmlFor={name}>
          {label}
        </label>
        <textarea
          rows="3"
          value={value}
          onChange={onChange}
          name={name}
          id={name}
          className="form-control input-style"
        ></textarea>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    );
  }
}

export default TextArea;
